<script setup lang="ts"></script>

<template>
  <main class="min-h-screen bg-gradient-to-b from-slate-50 to-white">
    <router-view />
  </main>
</template>

<style scoped></style>
